import axios from 'axios';

const deleteUser = id => axios.delete(`owner/users/${id}`);

const promoteUser = id => axios.post(`owner/users/${id}/promote`);

export { deleteUser, promoteUser };
